import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
//import { composeWithDevTools } from 'redux-devtools-extension';
import rootReducer from '../reducers';
import { loadState, saveState } from './persisted.store';

export default function configureStore() {
    const enhancers = [];
    const middleware = [thunk];

    if (process.env.NODE_ENV === 'development') {
        const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;
        if (typeof devToolsExtension === 'function') {
            enhancers.push(devToolsExtension());
        }
    }

    const composedEnhancers = compose(applyMiddleware(...middleware), ...enhancers);

    const persistedState = loadState();
    const store = createStore(rootReducer, persistedState, composedEnhancers);

    store.subscribe(() => {
        saveState(store.getState());
    });

    return store;
}



// WEBPACK FOOTER //
// ./src/store/configure.store.js